import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PageView, initGA } from './Tracking';

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { withStyles } from '@material-ui/core/styles';
import TeeSlot from './ui/teeSlot'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
import classnames from 'classnames'
import PhoneInput from './ui/phoneInput';
import EditIcon from '@material-ui/icons/Edit';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CloseIcon from '@material-ui/icons/Close'
import CardForm from './ui/cardForm';
import DatePicker from './ui/DatePicker'
import LoginComponent from './ui/LoginComponent';
import RegisterComponent from './ui/RegisterComponent'
import { connect } from 'react-redux'
import { signIn } from '../store/actions/authenticationActions'
import ResetPassword from './ui/ResetPassword';
import { getUserInfo, makeCardAsDefault, updateMemberInfo, addNewCard, addNewBankAcct, deleteCard, changeAllcalName, getFutureTeeTickets, getLinkAccountToken, addNewBankAcctAndMakeDefault, updatePayTerms, updateNameAndEmailAcrossPlatforms } from '../store/actions/accountActions';
import { QRCode } from "react-qr-svg";
import { resetPassword } from '../store/actions/authenticationActions'

import moment from 'moment'
import { CircularProgress, TextareaAutosize } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { withSnackbar } from 'notistack';

import queryString from 'query-string';
import { useLocation } from 'react-router-dom'
import { grey } from '@material-ui/core/colors';
import BankAccountForm from './ui/bankAccountForm';
import VerifyAmountForm from './ui/verifyAmountForm';
import LoginInOut from './ui/LoginInout'
import LinkAccountButton from './ui/linkAccountButton';

import { Link as MaterialLink } from '@material-ui/core'

import InfoIcon from '@material-ui/icons/Info';
import Chip from '@material-ui/core/Chip'


import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import SlideInModal from './ui/slideInModal';
import {Typography} from '@material-ui/core';

import { ACHDiscountWrapper } from './shared/genericFunctions'
import classNames from 'classnames';
import { getMemberInvites, inviteUser, logInvitedMember, getMembershipPhases} from '../store/actions/membershipActions';
import { constants } from '../App.constants';
import { Send } from '@material-ui/icons';

const styles = (theme) => ({
    root: {
        background: theme.palette.background.default,
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0),
        },
        width: '100%'

    },
    marginTop10Xs: {
        marginTop: theme.spacing(10),

    },
    indicator: {
        backgroundColor: 'transparent',
    },
    tabRoot: {
        minWidth: '100px',
        padding: 0,
        backgroundColor: 'white',
        marginLeft: theme.spacing(1),
        color: '#3F3F3F',

    },
    checkoutContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: theme.spacing(4)

    },
    header: {
        fontSize: theme.spacing(3),
        fontWeight: 700,
        color: theme.palette.text.primary,
        textTransform: 'uppercase'
    },
    topContainer: {
        width: '100%',
        paddingBottom: theme.spacing(5),
    },
    playersContainer: {
        marginLeft: theme.spacing(2)
    },
    padding2: {
        padding: theme.spacing(2)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    marginTop8: {
        marginTop: theme.spacing(8)
    },
    marginTop5: {

        marginTop: theme.spacing(5)
    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    button: {
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        letterSpacing: '1px',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: 'transparent'
        }
    },
    buttonPay: {
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: theme.palette.primary.main
        }
    },
    buttonCustomDashed: {
        color: '#009BE1',
        background: 'white',
        fontWeight: 600,
        border: '2px dashed #009BE1'

    },
    marginBottom2: {
        marginBottom: theme.spacing(3)
    },
    marginBottom1: {
        marginBottom: theme.spacing(1)
    },
    bold: {
        fontWeight: '600'
    },
    muted: {
        color: theme.palette.text.disabled
    },
    bgTransparent: {
        background: 'transparent'
    },
    bgWhite: {
        background: 'white'
    },
    bgDefault: {
        background: theme.palette.background.default,
        "& .MuiInputBase-input.Mui-disabled": {
            color: '#282c34'
        },

    },
    borderEnabled: {
        border: '1px solid #161717'
    },
    padding5: {
        padding: theme.spacing(5)
    },
    paddingTopBottom3Xs: {
        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3)
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(8)
        },

    },
    blackBorderButton: {

        border: '1px solid black',
        color: 'black',
        '&:hover': {
            backgroundColor: 'transparent',
            border: '1px solid black '
        }
    },
    xsButton: {
        padding: '0px 9px',

    },
    card: {
        marginRight: theme.spacing(1)
    },

    icon: {
        cursor: 'pointer'
    },
    marginTop1: {
        marginTop: theme.spacing(1)
    },
    successDiv: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        background: '#DEEFF8',
        marginBottom: '30px',
        color: '#005894',
    },
    warningDiv: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        background: '#e7feff',
        marginBottom: '30px',
        color: 'black',
    },
    cardHeader: {
        background: theme.palette.background.default,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        textAlign: 'center'
    },
    bookBtn: {
        textTransform: 'capitalize',
        fontSize: theme.spacing(2.25),
        paddingTop: '4px',
        paddingBottom: '4px'
    },
    ticketCard: {
        padding: theme.spacing(2)
    },
    padding1: {
        padding: theme.spacing(1)
    },
    greyBg: {
        background: theme.palette.background.default
    },
    paddingBottom10: {
        paddingBottom: theme.spacing(10)
    },
    paddingLeftRight1: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    paddingLeftRight2: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    footerText: {
        color: 'grey',
        textAlign: 'center'
    },
    black: {
        color: 'black'
    },
    tabRoot: {
        padding: 0,
        backgroundColor: 'white',
        color: '#3F3F3F',
        "&.Mui-selected": {
            background: theme.palette.primary.main,
            color: 'white'
        }
    },
    inputRoot: {
        padding: 0
    },
    info: {
        fontSize: theme.spacing(1.7),
        color: 'grey',
        fontWeight: '600'
    }
    
});


const MyAccount = (props) => {
    const [editClicked, setEditClicked] = useState(false)
    const [addCardClicked, setAddCardClicked] = useState(false)
    const [addBankAcctClicked, setAddBankAcctClicked] = useState(false)
    const [resetPwd, setResetPwd] = useState(false)
    const [registerFlg, setRegisterFlg] = useState(true);
    const account = useSelector(state => state.account)
    const dispatch = useDispatch()
    const isLoginTokenValid = useSelector(state => state.authentication.isLoginTokenValid)
    const currentUser = useSelector(state => state.authentication.currentUser)
    const [accountInState, setAccountInState] = useState(undefined)
    const [loading, setLoading] = useState(true)
    const [successDisplay, setSuccessDisplay] = useState(false)
    const { classes, enqueueSnackbar } = props;
    const location = useLocation()

    const [linkToken, setLinkToken] = useState(null);
    const [loadingPlaid, setLoadingPlaid] = useState(false);
    const [onlineBankBtnClicked, setOnlineBankBtnClicked] = useState(false);

    const [agreedToTermsAndConds, setAgreedToTermsAndConds] = useState(false)

    const [payTermsAndCond, setPayTermsAndCond] = useState(undefined)

    const [checkBoxPayTerms, setCheckBoxPayTerms] = useState(false)

    const [discountExist, setDiscountExist] = useState(false)
    const [addOnModalOpen, setAddOnModalOpen] = useState(false)
    const [addOnTypes, _] = useState(['Golf', 'Social'])
    const [selectedAddOnsInfo, setSelectedAddOnsInfo] = useState([{email: "", type: 0}])
    const [addOnEmailErr, setAddOnEmailErr] = useState([])
    const [formPristine, setFormPristine] = useState(true)
    const [inviteSendClick, setInviteSendClick] = useState(false)
    const isOAuthRedirect = window.location.href.includes('?oauth_state_id=');
    const [invitedMembers, setInvitedMembers] = useState([])
    const [eligibleForAddons, setEligibleForAddons] = useState(false)
    const [typeOfMembership, setTypeOfMembership] = useState(null)
    const [membershipScheduled, setMembershipScheduled] = useState([])

    const onEditClick = () => {
        setEditClicked(true)
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const onSaveClick = () => {
        if(!isValidEmail(accountInState.email)){
            enqueueSnackbar('Please enter a valid email to proceed', { variant: 'error' });
            return;
        }
        if (accountInState.nameInState === undefined && accountInState.nameInState === '') {
            enqueueSnackbar('Name field cannot be empty', {variant: 'error'})
            return
        }
        dispatch(updateMemberInfo(accountInState.linkToSavedMember, accountInState.phone, accountInState.address, accountInState.dateOfBirth, accountInState.emergencyContact, accountInState.emergencyContactName, (err, data) => {
            if(err){
                enqueueSnackbar('Update failed', { variant: 'error' });
                return
            }
            dispatch(changeAllcalName(accountInState.nameInState))
            dispatch(updateNameAndEmailAcrossPlatforms(accountInState.nameInState, accountInState.email))
            dispatch(getUserInfo(currentUser.userId, () => {
                enqueueSnackbar('Saved', { variant: 'success' });
            }))
        }))
        setEditClicked(false)
    }

    const a11yProps = (index) => {
        return {
            id: `scrollable-force-tab-${index}`,
            "aria-controls": `scrollable-force-tabpanel-${index}`
        };
    }

    const handleAddOnInviteChange = (type, val, rootIndex) => {
        const updatedAddOns = [...selectedAddOnsInfo];
            if (rootIndex >= 0 && rootIndex < updatedAddOns.length) {
                updatedAddOns[rootIndex] = {
                    ...updatedAddOns[rootIndex],
                    [type]: val
                };
                setSelectedAddOnsInfo(updatedAddOns);
            } else {
                console.warn('Invalid rootIndex:', rootIndex);
        }
        if(!formPristine){
            validateEmails()
        }
    }

    const onEmailChange = (e) => {
        setAccountInState({
            ...accountInState,
            email: e.target.value
        })
    }

    const handleRemoveAddOn = (index) => {
        const updatedAddOns = [...selectedAddOnsInfo]
        updatedAddOns.splice(index, 1)
        setSelectedAddOnsInfo(updatedAddOns)
    }

    const onCardAddClick = () => {
        setAddCardClicked(true)
        setAddBankAcctClicked(false)
        setOnlineBankBtnClicked(false)
    }
    const onOnlineBankClick = () => {
        setOnlineBankBtnClicked(true)
        setAddCardClicked(false)
        setAddBankAcctClicked(false)

    }
    const onBankAcctClick = () => {
        setAddBankAcctClicked(true)
        setAddCardClicked(false)
        setOnlineBankBtnClicked(false)
    }

    const refreshPaymentButtonClicks = () => {
        setOnlineBankBtnClicked(false)
        setAddCardClicked(false)
        setAddBankAcctClicked(false)
    }


    useEffect(() => {
        initGA('UA-214286621-1')
        PageView('/register-tanglewood');

        if (queryString.parse(location.search).regId) {
            setRegisterFlg(true)
        }

        if (isOAuthRedirect) {
            setLinkToken(localStorage.getItem('linkToken'))
            return;
        }
        dispatch(getLinkAccountToken(localStorage.getItem('userId'), "https://myaccount.tanglewoodresort.club/" , (err, data) => {
            console.log(data);
            if (!err) {
                setLinkToken(data.data.link_token)
                localStorage.setItem('linkToken', data.data.link_token)
            }
        }))

    }, [])
    useEffect(() => {
        setAccountInState({
            ...account
        })
        if (queryString.parse(location.search).success) {
            setSuccessDisplay(true)
        }
        if (account && Object.keys(account).length > 0) {
            if (account.metadata && account.metadata.recurringPayTermsAgreedOn) {
                setPayTermsAndCond(true)
                setCheckBoxPayTerms(true)
            } else {
                setPayTermsAndCond(false)
            }

            if (account.subscriptions && account.subscriptions.data && account.subscriptions.data.length > 0) {
                let isthereADiscount = false;
                account.subscriptions.data.forEach((subscription) => {
                    if (subscription.discount && subscription.discount.coupon && subscription.discount.coupon.id === 'ACHDISCOUNT') {
                        isthereADiscount = true;
                    }

                })

                if (isthereADiscount) {
                    setDiscountExist(true)
                } else {
                    setDiscountExist(false)
                }
            }
        }

        let primaryMembershipType = getType(account?.registrationTitle)
        
        if(primaryMembershipType === 'Golf' || primaryMembershipType === 'Social'){
            setEligibleForAddons(true)
            setTypeOfMembership(primaryMembershipType)
            if(primaryMembershipType === 'Social'){
                setSelectedAddOnsInfo([{"type": 1, email: ""}])
            }
        }
        getMemberInvitations()
        fetchMembershipPhases(account?.id)

    }, [account])

    useEffect(() => {
        if (currentUser) {
            setLoading(true)
            dispatch(getUserInfo(currentUser.userId, () => {
                dispatch(getFutureTeeTickets(() => {
                    setLoading(false);

                }))

            }))
        }
    }, [currentUser])


    const handleRecurringPayTermsChange = (e) => {
        setCheckBoxPayTerms(e.target.checked)
    }

    const handleOpenAddOnDialog = () => {
        setAddOnModalOpen(true)
        setInviteSendClick(false)
    }

    const handleCloseAddOnDialog = () => {
        setAddOnModalOpen(false)
        setSelectedAddOnsInfo([{email: "", type: 0}])
    }

    const fetchMembershipPhases = (accountId) => {
        if(accountId){
            dispatch(getMembershipPhases(localStorage.getItem('loginToken'), accountId, (err, data) => {
                
                if(!err){
                    if(data?.data.length > 0){
                        setMembershipScheduled(data.data)
            
                    }
                }
            }))
        } 
    }

    const handleMoreAddOnClick = () => {
         let addOnObj = {email: '', type : 0}
        if(typeOfMembership === 'Social'){
            addOnObj['type'] = 1
        }
        setSelectedAddOnsInfo([
            ...selectedAddOnsInfo,
            addOnObj
        ])
    }

    function getType(input) {
        if (!input) return null;

        const text = input.toLowerCase();

        const addOnPattern = /\badd[\s-]*on\b/i;

        const golfPattern = /\bgolf\b/i;
        const socialPattern = /\bsocial\b/i;

        if (addOnPattern.test(text)) {
            return null;
        }
        if (golfPattern.test(text)) return "Golf";
        if (socialPattern.test(text)) return "Social";

        return null;
    }

    const validateEmails = () => {
        const errors = [];

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        selectedAddOnsInfo.forEach((item, index) => {
            const email = item.email;

            if (!email || typeof email !== 'string' || email.trim() === '') {
                errors.push({
                    index,
                    message: `Email is required`,
                });
            } else if (!emailRegex.test(email.trim())) {
                errors.push({
                    index,
                    message: `Invalid email format`,
                });
            }
        });
        setAddOnEmailErr(errors)   
        return errors;
    };

    const handleSendInvite = () => {
        setFormPristine(false)
        setInviteSendClick(true)
        const errors =  validateEmails()

        if(errors.length == 0){

            selectedAddOnsInfo.forEach((item, index) => {

                const { golfAddOnUrl, socialAddOnUrl, SENDGRID_INVITE_ADD_ON_TEMPLATE, golfAddOnRegId, socialAddOnRegId } = constants
                let messageInfo = {}
                messageInfo.primaryMemberName = currentUser.name
                messageInfo.email = item.email
                messageInfo.type = (item.type === 0) ? 'Golf Add-on' : 'Social Add-on'
                messageInfo.url = (item.type == 0) ? golfAddOnUrl : socialAddOnUrl 
                messageInfo.regId = (item.type === 0) ? golfAddOnRegId : socialAddOnRegId

                dispatch(inviteUser(messageInfo, SENDGRID_INVITE_ADD_ON_TEMPLATE, () =>{
                    dispatch(logInvitedMember(accountInState.email, item.email, messageInfo.type, messageInfo.regId, 'invited', ()=> {
                        getMemberInvitations()    
                    }))

                }))
            })
            handleCloseAddOnDialog()

        }else{
            setInviteSendClick(false)
        }
    }

    const resendInvite = (item) => {
        const { golfAddOnUrl, socialAddOnUrl, SENDGRID_INVITE_ADD_ON_TEMPLATE } = constants
        let messageInfo = {}
        messageInfo.primaryMemberName = currentUser.name
        messageInfo.email = item.invitedMemberEmail
        messageInfo.type = item.membershipType
        messageInfo.url = (item.membershipType == 'Golf Add-on') ? golfAddOnUrl : socialAddOnUrl 
        messageInfo.regId = item.registrationId

        dispatch(inviteUser(messageInfo, SENDGRID_INVITE_ADD_ON_TEMPLATE, () =>{
            dispatch(logInvitedMember(accountInState.email, item.invitedMemberEmail, messageInfo.type, messageInfo.regId, 'invited', ()=> {
                enqueueSnackbar('Resent invitation', { variant: 'success' });
                getMemberInvitations()    
            }))

        }))
    }

    const getMemberInvitations = () => {
        if(accountInState?.email){
             dispatch(getMemberInvites(accountInState.email, (err, addOnMembers)=> {
                if(!err){
                    setInvitedMembers(addOnMembers)
                }
            }))
        }

    }

    const handleTokenCallback = (token, cb) => {
        console.log(token)
        dispatch(addNewCard(token, account.id, payTermsAndCond, (err) => {
            if (!err) {
                dispatch(getUserInfo(currentUser.userId, (err, account) => {
                    enqueueSnackbar('Card added successfully', { variant: 'success' });
                    //TO-DO: check if there is discount previously applied on the subscription ; if so remove it 
                    ACHDiscountWrapper(account, 'delete', currentUser, dispatch);
                }))
                setAddCardClicked(false);
            }
        }))
        cb(null)

    }
    const handleBackAcctTokenCallback = (token, cb) => {

        dispatch(addNewBankAcct(token, account.id, payTermsAndCond, (err) => {
            console.log(err)
            if (!err) {
                dispatch(getUserInfo(currentUser.userId, () => {
                    enqueueSnackbar('Bank Account added successfully', { variant: 'success' });
                }))

                setAddBankAcctClicked(false)
            }
        }))

    }

    const handlePlaidBackAcctTokenCallback = (tokenObj, cb) => {
        setLoadingPlaid(true);

        dispatch(getUserInfo(currentUser.userId, (err, resp) => {

            dispatch(addNewBankAcctAndMakeDefault({ id: tokenObj.stripe_bank_account_token }, resp.id, payTermsAndCond, (err) => {
                console.log(err)
                if (!err) {
                    dispatch(getUserInfo(currentUser.userId, (err, account) => {
                        enqueueSnackbar('Bank Account added successfully', { variant: 'success' });
                        //TO-DO: Check if discount already applied for the subscription if not apply the discount 
                        ACHDiscountWrapper(account, 'apply', currentUser, dispatch)
                    }))

                    setAddBankAcctClicked(false);
                    setLoadingPlaid(false);
                }
            }))
        }));

        refreshPaymentButtonClicks();


    }

    const handlePhoneChangeFn = (tel) => {
        console.log(tel)
        setAccountInState({
            ...accountInState,
            phone: tel
        })
    }
    const handleEmerPhoneChange = (tel) => {
        setAccountInState({
            ...accountInState,
            emergencyContact: tel
        })

    }
    const formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        } else {
            return phoneNumberString
        }
    }

    const formatTextArea = (address) => {
        if (address) {

            return address.replace(/(\r\n|\n|\r)/gm, " ")
        }
        return address
    }

    const loginFn = (values) => {
        dispatch(signIn(values, (err) => {
            if (!err) {
                window.location.reload()
            } else {
                enqueueSnackbar(err, { variant: 'error' })
            }

        }))

    }

    const onAddressChange = (e) => {
        console.log(e.target.value)
        setAccountInState({
            ...accountInState,
            address: e.target.value
        })
    }

    const resetFn = () => {
        setResetPwd(true)

    }

    const resetToLogin = () => {
        setRegisterFlg(false);
    }
    const createNewAcctFn = () => {
        setRegisterFlg(true)
    }
    const backToLoginFn = () => {
        setResetPwd(false)

    }

    function sanitizeEmailObj({ email }) {
        if (typeof email !== "string") return { email: "" };

        const sanitized = email
            .trim()
            .toLowerCase()
            .replace(/[^\w.@+-]/g, "");

        return { email: sanitized };
    }

    const resetPwdFn = (values) => {
        console.log(values);
        dispatch(resetPassword(sanitizeEmailObj(values), (err) => {
            if (!err) {

                enqueueSnackbar('Check your email inbox for further instructions', { variant: 'success' })
                setResetPwd(false)
            }
        }))
    }
    const onNameChange = (e) => {
        setAccountInState({
            ...accountInState,
            nameInState: e.target.value
        })
    }

    const onDOBChange = (date) => {
        setAccountInState({
            ...accountInState,
            dateOfBirth: date
        })
    }

    const onPhoneChange = (e) => {
        setAccountInState({
            ...accountInState,
            phone: e.target.value
        })
    }


    const onEmergencyContactNameChange = (e) => {
        setAccountInState({
            ...accountInState,
            emergencyContactName: e.target.value
        })
    }

    const onEmergencyPhoneChange = (e) => {

    }
    const deleteCardFn = (cardId) => {
        console.log(cardId)
        dispatch(deleteCard(cardId, account.id, (err) => {
            if (!err) {
                dispatch(getUserInfo(currentUser.userId, (err, accountInfo) => {
                    enqueueSnackbar('Card deleted successfully', { variant: 'success' });
                    //TO-DO: Here check if the current default source is bank account - if not revert discount 
                    ACHDiscountWrapper(accountInfo, 'checkAndDelete', currentUser, dispatch);

                }))
            }
        }))
    }
    const makeCardAsDefaultFn = (cardId, customerId) => {
        console.log("Making card / bank account as default");
        if (customerId) {
            dispatch(makeCardAsDefault(cardId, customerId, (err, data) => {
                if (!err) {
                    dispatch(getUserInfo(currentUser.userId, (err, accountInfo) => {
                        console.log(accountInfo);
                        enqueueSnackbar('Card successfully set as default', { variant: 'success' });
                        //TO-DO: Here check if the current default source is bank account - if yes - check if there is discount already applied - if not apply the discount  
                        ACHDiscountWrapper(accountInfo, 'apply', currentUser, dispatch);
                    }))
                } else {
                    //err toastr
                    enqueueSnackbar('Error setting card as default', { variant: 'error' });
                }

            }))
        } else {

        }

    }

    const payTermsAgreed = (customerId) => {
        setAgreedToTermsAndConds(true);

        //update
        dispatch(updatePayTerms(customerId, () => {
            setTimeout(() => {
                dispatch(getUserInfo(currentUser.userId, () => {

                }))
            }, 3000);
        }))

    }
    return <Fragment>{

        isLoginTokenValid && accountInState && <div className={classes.root}>


            <Grid container item wrap='wrap' justify="center" className={classnames(classes.bgWhite, classes.paddingTopBottom3Xs)} xs={12} >
                <LoginInOut></LoginInOut>

                {successDisplay && <Grid item xs={12} ><div className={classes.successDiv} >Your TeeTime has been successfully added to your account
                </div></Grid>}
               
                {accountInState && <Grid item md xs={12} >
                    <Paper className={classes.padding3}>
                        <Grid item className={classnames(classes.bold)} >
                            <Paper className={classnames(classes.bgTransparent)}>Your upcoming Tee Times</Paper>
                        </Grid>

                        {
                            accountInState && accountInState.tickets && accountInState.tickets.length > 0 ?
                                <Fragment>
                                    <Grid container justify="space-between" className={classnames(classes.marginTop2)}>

                                        {accountInState.tickets.map((ticket, index) => {
                                            return <Grid key={index} container item xs={12} sm={6} className={classes.padding1} >
                                                <Grid container justify="space-between" alignItems="center" className={classnames(classes.greyBg)} >
                                                    <Grid item xs={8}>
                                                        <Grid container direction="column" spacing={1} className={classes.ticketCard}>
                                                            <Grid item >{ticket.player.name}</Grid>
                                                            <Grid item className={classes.bold}>{ticket.postingMeta.title}  | {ticket.eventInfo.eventDateStr}</Grid>
                                                            <Grid item >1 person</Grid>
                                                            <Grid item >{ticket.eventInfo.eventLocation}</Grid>
                                                        </Grid>

                                                    </Grid>
                                                    <Grid item xs={4} >
                                                        <Grid container justify="flex-end" className={classes.ticketCard}>
                                                            <QRCode
                                                                bgColor="#FFFFFF"
                                                                fgColor="#000000"
                                                                level="Q"
                                                                style={{ width: '120px', height: '100%' }}
                                                                value={ticket.ticketId}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                        })}

                                    </Grid>

                                </Fragment>
                                : !loading ? <Grid container item justify="center" className={classnames(classes.marginTop3, classes.cardHeader)}>
                                    <Grid container item xs={12} md={10} lg={7} spacing={2} direction={'column'}>
                                        <Grid item  >
                                            You have no tee times booked right now
                                        </Grid>
                                        <Grid container item justify="center">
                                            <Grid item xs={10} sm={6} lg={5} >
                                                <Button className={classes.bookBtn} variant="contained" onClick={() => window.location.href = "https://tanglewood-teetimes.allcal.com/#/"}  fullWidth={true} size="large" color="primary">Book Tee Time</Button>
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            {/* TO-DO */}
                                            Questions about your Tee Time or need to make a change? Please call our Pro Shop: <span className={classnames(classes.bold, classes.paddingLeftRight1)}>903-786-4638</span>
                                        </Grid>
                                    </Grid>

                                </Grid> : <Grid container item justify="center"><Grid item><CircularProgress size={24} className={classes.marginTop3} ></CircularProgress></Grid></Grid>
                        }


                    </Paper>
                </Grid>}
                <Grid container item justify="space-between" alignItems="center">
                    <Grid item className={classnames(classes.bold)} >
                        <Paper className={classnames(classes.bgTransparent, classes.marginTop2)}>Account Details</Paper>
                    </Grid>
                    <Grid item className={classnames(classes.bold, classes.marginTop2)} >
                        {!editClicked ? <Button
                            variant="outlined"
                            color="primary"
                            disabled={account.paperInfoExists === false}
                            onClick={onEditClick}
                            size="small"
                            startIcon={<EditIcon className={classes.icon} fontSize="large" ></EditIcon>}

                        >
                            Edit Details
                        </Button> : <Button
                            variant="outlined"
                            color="secondary"
                            onClick={onSaveClick}
                            size="small"
                            startIcon={<CheckBoxIcon className={classes.icon} fontSize="large" ></CheckBoxIcon>}

                        >
                            Save Details
                        </Button>}
                    </Grid>

                </Grid>
                <Grid container justifyContent='space-between'>
                    <Grid item md={6} xs={12}>

                    <Paper className={classnames(classes.bgTransparent)}>

                        <Grid container className={classes.marginTop2} alignItems="center" >
                            <Grid item xs={12} sm={3} ><Paper className={classes.bgTransparent}>Name</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}><TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder="Enter name" value={accountInState.nameInState ? accountInState.nameInState : currentUser.name} onChange={onNameChange} /></Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Member ID</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault)}><TextField InputProps={{ disableUnderline: true, disabled: true }} fullWidth value={accountInState.memberIdProvidedByOrganizer} /></Paper></Grid>
                        </Grid>

                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Email</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}><TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth value={accountInState.email ? accountInState.email : currentUser.email} onChange={onEmailChange} /></Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Date of Birth</Paper></Grid>
                            <Grid item xs>{!editClicked ? <Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}> <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Date of Birth' : ''} value={!loading && accountInState.dateOfBirth ? moment(accountInState.dateOfBirth).format('MM/DD/YYYY') : ''} /></Paper>
                                : <DatePicker selectedDate={accountInState.dateOfBirth ? accountInState.dateOfBirth : new Date().toISOString()} onChangeDate={onDOBChange}></DatePicker>}</Grid>
                        </Grid>

                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Phone</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}>
                                {editClicked ? <PhoneInput value={accountInState.phone} handlePhoneChange={handlePhoneChangeFn}></PhoneInput> : <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth value={formatPhoneNumber(accountInState.phone)} />}

                            </Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Address</Paper></Grid>
                            <Grid item xs>

                                {!editClicked ? <Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}>
                                    <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Address' : ''} value={formatTextArea(accountInState.address)} onChange={onAddressChange} />
                                </Paper> : <TextareaAutosize style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid black' }} InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Address' : ''} value={accountInState.address} onChange={onAddressChange} />}

                            </Grid>

                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Emergency Contact Name</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}><TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Emergency Contact Name' : ''} value={accountInState.emergencyContactName} onChange={onEmergencyContactNameChange} /></Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Emergency Contact Phone</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}>
                                {editClicked ? <PhoneInput value={accountInState.emergencyContact} handlePhoneChange={handleEmerPhoneChange}></PhoneInput> : <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth value={formatPhoneNumber(account.emergencyContact)} />}

                            </Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Member Since</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault)}><TextField InputProps={{ disableUnderline: true, disabled: true }} fullWidth value={!loading ? moment(account.createdTime).format('MMM D, YYYY') : ''} /></Paper></Grid>
                        </Grid>

                    </Paper>


                    </Grid>
                    <Grid item md={5} xs={12} className={classes.marginTop2}>
                        <Paper className={classnames(classes.padding2, classes.bgDefault)}>
                            <Grid container item direction="column" >
                                <Grid container direction="column" spacing={1} >
                                    <Grid item className={classes.bold}>Membership</Grid>
                                    {account.registrationTitle ? <Grid item >{account.registrationTitle} <Grid container item style={{ marginTop: '4px' }} > </Grid></Grid> : <Grid item>-</Grid>}
                                </Grid>
                                <Grid container item className={classes.marginTop2}> 
                                    <Grid item xs={12} md={8}><Button
                                        variant="outlined"
                                        color="primary"
                                        disabled={(account.stripeUserInfoExists === false) || !eligibleForAddons || invitedMembers.length >= 3 || membershipScheduled.length > 0}
                                        onClick={handleOpenAddOnDialog}
                                        size="large"
                                        fullWidth
                                    >
                                        Enroll Add-on Family Member 
                                    </Button></Grid>
                                    {
                                       account?.id && membershipScheduled.length > 0 && eligibleForAddons && <Grid item xs={12} md={12}>
                                            <Typography variant='p' className={classes.info}>You will be able to invite add-on members on { moment.tz( membershipScheduled[0]?.phases[0]?.start_date * 1000 ,  'America/New_York').format('MMM D, YYYY')}</Typography>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid container className={classes.marginTop2}>
                                    <Grid item className={classes.bold}>Add-on Members</Grid>
                                </Grid>
                                <Grid container item className={classes.marginTop2}>

                                        {
                                            invitedMembers.map((member) => <Grid container item justifyContent='space-between' alignItems='center'>
                                                <Grid item xs={9} md={7}>
                                                    {member.invitedMemberEmail}
                                                </Grid>
                                                <Grid item xs={3} md={3}>
                                                    {member.membershipType} {member.status === 'invited' && ' (pending)'}
                                                </Grid>
                                                <Grid item xs>
                                                    {member.status === 'invited' ? <Button color='primary' size='small' onClick={() => resendInvite(member)}>Resend Invite</Button>: ''}
                                                </Grid>
                                            </Grid>)
                                        }

                                </Grid>

                            <SlideInModal handleClose={() => handleCloseAddOnDialog()} openModal={addOnModalOpen}>
                                    <Grid container spacing={3} direction='column' className={classes.paddingBottom10}>
                                        <Grid container item justifyContent='center'>
                                            <Typography variant="h4">Add-on Memberships</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography>Benefits are the same as Golf (or) Social Member </Typography>
                                            <Typography>Must be in the same household as the primary member</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography> Golf Add-on Membership <strong>$100/ month</strong></Typography>
                                            <Typography>Social Add-on Membership <strong>$25/ month</strong></Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography> <strong>3 add-on</strong> family members allowed per membership</Typography>
                                        </Grid>

                                        {selectedAddOnsInfo.map( (addOn, rootIndex) => <Grid container item alignItems='center' justifyContent='center'>
                                            <Grid item>
                                            <TextField
                                                    required
                                                    label={'#' + (rootIndex + 1) + ' Email'}
                                                    variant="standard"
                                                    type='email'
                                                    value = {addOn.email}
                                                    helperText={addOnEmailErr.find(err => err.index === rootIndex)?.message}
                                                    error={addOnEmailErr.find(err => err.index === rootIndex)}
                                                    onChange={(e) => handleAddOnInviteChange('email', e.target.value, rootIndex)}
                                                    classes={{

                                                            root: classNames.inputRoot

                                                    }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Tabs
                                                    value={addOn.type}
                                                    onChange={(e, index) => handleAddOnInviteChange('type', index, rootIndex)}
                                                    classes={{
                                                        indicator: classes.indicator
                                                    }}
                                                    variant="scrollable"
                                                    scrollButtons="on"
                                                    indicatorColor="primary"
                                                    textColor="primary"
                                                    aria-label="scrollable force tabs example"
                                                >
                                                    {
                                                        addOnTypes && addOnTypes.map((type, index) => {
                                                            return <Tab
                                                                key={index}
                                                                className={classes.tabRoot}
                                                                disabled={typeOfMembership === 'Social'}
                                                                icon={
                                                                    <div style={{ textTransform: 'capitalize' }}>
                                                                        <div style={{ fontSize: '16px', fontWeight: 700 }}>{type}</div>
                                                                    </div>
                                                                }
                                                                {...a11yProps(index)}
                                                            />
                                                        })

                                                    }

                                                </Tabs>

                                            </Grid>
                                            { selectedAddOnsInfo.length > 1 && <Grid item>
                                                    <CloseIcon onClick={()=> handleRemoveAddOn(rootIndex)}></CloseIcon>
                                            </Grid>}      
                                        </Grid>)}  
                                        <Grid container item justifyContent='center'>
                                            <Button 
                                                variant="outlined"
                                                color="primary"
                                                disabled={selectedAddOnsInfo.length > 2 || invitedMembers.length >= 2}
                                                onClick={handleMoreAddOnClick}
                                                size="large"
                                            >
                                                + Add Another
                                            </Button>
                                        </Grid>     

                                        <Grid container item justifyContent='center' className={classes.marginTop8}>
                                            <Button
                                                variant='contained'
                                                color="primary"
                                                onClick={handleSendInvite}
                                                disabled={inviteSendClick}
                                                size="large"
                                            >
                                                Send Invite
                                            </Button>
                                        </Grid>  
                                    </Grid>





                            </SlideInModal>

                                {account.stripeUserInfoExists !== false && <Grid container direction="column" spacing={1} >
                                    <Grid item className={classnames(classes.bold, classes.marginTop3)}>Standing</Grid>
                                    {account.delinquent ? <Grid item >Delinquent</Grid> : <Grid item>Good</Grid>}
                                </Grid>}

                                <Grid container direction="column" spacing={1} >
                                    <Grid item ><Paper className={classnames(classes.bold, classes.marginTop3, classes.bgDefault)}>Payment Methods on File {loadingPlaid && <CircularProgress size={16}></CircularProgress>}</Paper></Grid>
                                    {account.sources && account.sources.data.length > 0 ?

                                        account.sources.data.map((card) => {
                                            return card.type !== 'ach_credit_transfer' && <Grid item container justify="space-between" alignItems="center" className={classes.marginBottom1}><Grid container item xs={10} alignItems="center" >
                                                <Paper className={classnames(classes.bgDefault, classes.card)}>{card.brand ? card.brand : card.bank_name} ending in {card.last4} </Paper>
                                                {card.object !== 'bank_account' ?
                                                    <Button size="small" className={classes.xsButton} color={card.id === account.default_source ? 'primary' : 'none'} variant={card.id === account.default_source ? 'contained' : 'text'} onClick={() => makeCardAsDefaultFn(card.id, account.id)}> DEFAULT</Button>
                                                    :
                                                    <Fragment>
                                                        {card.status === 'verified' ? <Button size="small" className={classes.xsButton} color={card.id === account.default_source ? 'primary' : 'none'} variant={card.id === account.default_source ? 'contained' : 'text'} onClick={() => makeCardAsDefaultFn(card.id, account.id)}> DEFAULT</Button> :
                                                            <Button size="small" className={classes.xsButton} color={card.status === account.default_source ? 'primary' : 'none'} variant={card.id === account.default_source ? 'contained' : 'text'} > {card.status === 'new' ? 'Unverified' : card.status}</Button>

                                                        }
                                                    </Fragment>
                                                }
                                            </Grid>
                                                {account?.sources && account?.sources?.data.length > 1 && <Grid container alignItems="center" item xs justify="flex-end">
                                                    <DeleteForeverIcon className={classnames(classes.red, classes.icon)} onClick={() => { deleteCardFn(card.id) }}>
                                                    </DeleteForeverIcon>
                                                </Grid>}

                                                {
                                                    card.object === 'bank_account' && (card.status === 'new' || card.status === 'verification_failed' || card.status === 'errored') && <Grid container>
                                                        <VerifyAmountForm customerId={account.id} source={card.id} ></VerifyAmountForm>
                                                    </Grid>
                                                }

                                            </Grid>
                                        })

                                        : <Grid item ><Paper className={classes.bgDefault}>No cards on file</Paper></Grid>
                                    }
                                    {(!addCardClicked) && <Grid item xs><Button
                                        variant="outlined"
                                        color="primary"
                                        disabled={account.stripeUserInfoExists === false}
                                        onClick={onCardAddClick}
                                        className={classes.blackBorderButton}
                                        size="large"
                                        fullWidth={true}
                                    >
                                        + Add New Card
                                    </Button></Grid>}
                                    {addCardClicked && <CardForm disabled={payTermsAndCond} handleTokenCallback={handleTokenCallback}></CardForm>}
                                    {linkToken && <Grid item xs><Button
                                        variant="outlined"
                                        color="primary"
                                        disabled={account.stripeUserInfoExists === false}
                                        onClick={onOnlineBankClick}
                                        className={classes.blackBorderButton}
                                        size="large"
                                        fullWidth={true}
                                    >
                                        + Online Banking - add Bank account
                                    </Button></Grid>}

                                    {
                                        onlineBankBtnClicked && <Fragment><Grid item >
                                            {!payTermsAndCond && <FormGroup aria-label="position" row>
                                                <FormControlLabel
                                                    value="end"
                                                    control={<Checkbox color="primary" value={checkBoxPayTerms} onChange={handleRecurringPayTermsChange} />}
                                                    label={<div>I agree to the recurring payment <MaterialLink target="_blank" href="https://register.tanglewoodresort.club/#/recurring-payment-terms">terms and conditions</MaterialLink>.</div>}
                                                    labelPlacement="end"
                                                />
                                            </FormGroup>}
                                        </Grid><Grid container item justify="flex-end">{linkToken && <LinkAccountButton primaryColor={true} fullWidth={false} disabled={checkBoxPayTerms} stripeUserInfoExists={account.stripeUserInfoExists} token={linkToken} handleTokenCallback={handlePlaidBackAcctTokenCallback} isOAuthRedirect={isOAuthRedirect} label="continue"></LinkAccountButton>}
                                            </Grid></Fragment>
                                    }


                                    {!addBankAcctClicked && <Grid item xs><Button
                                        variant="outlined"
                                        color="primary"
                                        disabled={account.stripeUserInfoExists === false}
                                        onClick={onBankAcctClick}
                                        className={classes.blackBorderButton}
                                        size="large"
                                        fullWidth={true}
                                    >
                                        + Add Bank Account
                                    </Button></Grid>}
                                    {addBankAcctClicked && <BankAccountForm disabled={payTermsAndCond} handleTokenCallback={handleBackAcctTokenCallback}></BankAccountForm>}

                                </Grid>

                                <Grid container direction="column" spacing={1} >
                                    <Grid item ><Paper className={classnames(classes.bold, classes.marginTop3, classes.bgDefault)}>Upcoming Invoice</Paper></Grid>

                                    {account.subscriptions && account.subscriptions.data && account.subscriptions.data.length > 0 ?
                                        account.subscriptions.data.map((sub) => <Grid item ><Paper className={classes.bgDefault}>{moment(sub.current_period_end * 1000).format('MMM D')}</Paper></Grid>)
                                        : <Grid item > {!loading ? <Paper className={classes.bgDefault}>None</Paper> : <CircularProgress size={16}></CircularProgress>} </Grid>
                                    }

                                </Grid>


                                <Grid container direction="column" spacing={1} >
                                    <Grid item ><Paper className={classnames(classes.bold, classes.marginTop3, classes.bgDefault)}>Pending Member Charges</Paper></Grid>
                                    {account.invoiceItems && account.invoiceItems.length > 0 ?
                                        account.invoiceItems.map((invoice) => <Grid item> <Paper className={classes.bgDefault}>${invoice.amount / 100} {invoice.description} added on {moment(invoice.date * 1000).format('lll')}</Paper> </Grid>)
                                        : <Grid item>{!loading ? <Paper className={classes.bgDefault}>None</Paper> : <CircularProgress size={16}></CircularProgress>} </Grid>
                                    }


                                </Grid>


                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>        
                <Grid container justify="center" spacing={1} className={classnames(classes.marginTop3, classes.footerText)} >
                    {accountInState && accountInState.tickets && accountInState.tickets.length > 0 && <Grid item xs={12} >
                        Questions about your Tee Time or need to make a change? Please call our Pro Shop: <span className={classnames(classes.bold, classes.paddingLeftRight1, classes.black)}>  </span> 

                    </Grid>}
                    <Grid item xs={12} >
                        {/* TO-DO: admin email */}
                        Questions about your account? Please email Tanya Vincent<span className={classnames(classes.bold, classes.paddingLeftRight1, classes.black)}>  tvincent@tanglewoodresort.com  </span>
                    </Grid>
                </Grid>

            </Grid>

        </div >

    }
        {
            !isLoginTokenValid && < div className={classes.root}>
                <Grid container item xs={12} justify="center" className={classnames(classes.bgWhite, classes.paddingTopBottom3)}>

                    {!resetPwd ? registerFlg ? <RegisterComponent resetFn={resetToLogin} ></RegisterComponent> : <LoginComponent loginFn={loginFn} resetFn={resetFn} createNewAcctFn={createNewAcctFn} ></LoginComponent> :
                        <ResetPassword resetPwdFn={resetPwdFn} backToLoginFn={backToLoginFn}></ResetPassword>}

                </Grid>
            </div>
        }


    </Fragment >

}


export default withStyles(styles)(withSnackbar(MyAccount))